import styled from 'styled-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const TagsWrapper = styled.section`
  position: relative;
`;
export const FilterTagWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  flex-wrap: wrap;
  // overflow-x: scroll;
  width: 100%;
  white-space: nowrap;
  padding-top: 36px;
  padding-bottom: 32px;
  ::-webkit-scrollbar {
    display: none;
  }
  @media ${device.laptop} {
    gap: 12px;
    padding-top: 8px;
    padding-bottom: 12px;
    margin: 32px 0;
    flex-wrap: wrap;
  }
`;

export const ResetFiltersCTA = styled.button`
  font-family: Audi Type;
  color: ${COLORS.grey80};
  border: none;
  background: initial;
  display: flex;
  flex-direction: row;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  gap: 4px;
  cursor: pointer;
  margin-right: 12px;

  @media ${device.laptop} {
    color: ${COLORS.grey60};
  }
`;

export const ResetLabel = styled.p`
  padding-bottom: 4px;
  border-bottom: 1px solid ${COLORS.grey80};

  @media ${device.laptop} {
    border-bottom: 1px solid ${COLORS.grey60};
  }
`;

export const FilterCount = styled.p``;

export const Label = styled.p`
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
`;

export const IconBox = styled.button`
  background: initial;
  padding: 0;
  border: none;
  height: 24px;
  width: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const FilterTag = styled.div`
  padding: 4px 12px;
  height: 32px;
  background-color: rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
`;
